import { render, staticRenderFns } from "./DocumentsNew.vue?vue&type=template&id=21731aea&scoped=true"
import script from "./DocumentsNew.vue?vue&type=script&lang=ts"
export * from "./DocumentsNew.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsNew.vue?vue&type=style&index=0&id=21731aea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21731aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21731aea')) {
      api.createRecord('21731aea', component.options)
    } else {
      api.reload('21731aea', component.options)
    }
    module.hot.accept("./DocumentsNew.vue?vue&type=template&id=21731aea&scoped=true", function () {
      api.rerender('21731aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/DocumentsNew.vue"
export default component.exports